import { MoreHorizontal } from 'lucide-react';
import { ActionMenu, type ActionMenuItem } from '@/shared/components';

/**
 * Aktionsmenü einer Akte-Zeile.
 *
 * Ersetzt die `opacity-0 group-hover:opacity-100`-Leisten der Vertrags-, Rechnungs- und
 * Ausgangsrechnungszeilen. Ohne Zeiger gibt es kein Hover: Bearbeiten, Herunterladen, Kündigen
 * und Löschen waren auf dem Telefon schlicht nicht erreichbar (§9). Ein immer sichtbarer
 * Auslöser mit 44-px-Ziel ist zugleich die Form, die die Dateizeile schon nutzt.
 */
export function AkteRowMenu({
  items,
  label = 'Aktionen',
}: {
  items: ActionMenuItem[];
  label?: string;
}) {
  return (
    <ActionMenu
      trigger={
        <button
          type="button"
          aria-label={label}
          className="text-ink-faint hover:text-ink flex h-11 w-11 shrink-0 items-center justify-center rounded transition-colors"
        >
          <MoreHorizontal size={16} />
        </button>
      }
      items={items}
    />
  );
}
